var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',_vm._g(_vm._b({attrs:{"type":"default","round":""}},'van-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }